export const offlineGetFirebaseFileURL = (filePath: string): string => {
  const filePathFormatted = filePath.replace(/\//g, "%2F") as string
  const url = `https://firebasestorage.googleapis.com/v0/b/anjumori-f0a76.appspot.com/o/${filePathFormatted}?alt=media`
  return url
}